import { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import Pagination from "../../common/Pagination/Pagination";
import { Translate } from "../../Enums/Tranlate";
import CardItem from "./CardItem";
import "./style.scss";
import AddAdminsModal from "./AddAdminsModal";
import AdminService from "../../../services/AdminService";

const Admins = () => {
	const [admins, setAdmins] = useState(null);
	const [addModal, setAddModal] = useState(false);
	const [hasData, setHasData] = useState(null);
	const [item, setItem] = useState({});
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const adminService = new AdminService();
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<div className="admin">
			<div className="mb-3">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].admins}
						</span>
					</div>
					<div className="add-admin">
						<Button
							variant="primary"
							className="me-2 h-75"
							onClick={() => {
								setItem({});
								setAddModal(true);
							}}>
							<i
								className={`la la-plus ${lang === "en" ? "mr-2" : "ml-2"}`}></i>
							{Translate[lang]?.add_admin}
						</Button>
					</div>
				</div>
			</div>

			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									<th>
										<strong>{Translate[lang]?.name}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.phone}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.email}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.status}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.action}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{admins?.length > 0 &&
									admins?.map((item, index) => {
										return (
											<CardItem
												key={index}
												index={index}
												item={item}
												setShouldUpdate={setShouldUpdate}
												setItem={setItem}
												setAddModal={setAddModal}
											/>
										);
									})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setAdmins}
						service={adminService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
					/>
				</div>
			</div>
			{addModal && (
				<AddAdminsModal
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
					item={item}
				/>
			)}
		</div>
	);
};
export default Admins;
